// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import DateRange from '@deere/cps-it.warranty-model-factory/lib/date-range';
import {FormattedMessage} from 'react-intl';
import WarrantyDateRangePicker from '../../../shared/components/warranty-date-range-picker/warranty-date-range-picker';

const MaintenancePlanDateRangeItem = props => {

    const range = new DateRange({
        ...props.dateRange
    });

    return (

        <div className='maintenance-plan-date-range-item'>
            <h3 className={`${props.isRequired ? 'form-group-title asterisk-after' : 'form-group-title optional-criteria'}`}>
                <FormattedMessage id={props.label}/>
            </h3>
            <WarrantyDateRangePicker
                dateRange={range}
                maxDate={props.dateRange.max}
                minDate={props.dateRange.min}
                onDateChange={props.onDateChange}
            />
        </div>

    );

};

MaintenancePlanDateRangeItem.displayName = 'MaintenancePlanDateRangeItem';
MaintenancePlanDateRangeItem.propTypes = {
    dateRange: PropTypes.instanceOf(DateRange).isRequired,
    isRequired: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    onDateChange: PropTypes.func.isRequired
};

export default MaintenancePlanDateRangeItem;



// WEBPACK FOOTER //
// ./src/reports/maintenance-plan/components/maintenance-plan-date-range-item.js